import { Group, ActionIcon } from '@mantine/core';
import { IconStar, IconStarFilled } from '@tabler/icons-react';
import { useState } from 'react';

interface InterestRatingProps {
  value: number;
  onChange: (value: number) => void;
  max?: number;
  size?: number;
}

function InterestRating({ value, onChange, max = 3, size = 20 }: InterestRatingProps) {
  const [hovered, setHovered] = useState<number>(0);

  const getColor = (index: number): string => {
    const isHovered = hovered > 0 && index <= hovered;
    const isSelected = hovered === 0 && index <= value;
    if (isHovered) return 'var(--mantine-color-yellow-5)';
    if (isSelected) return 'var(--mantine-color-yellow-7)';
    return 'var(--mantine-color-gray-4)';
  };

  const handleClick = (index: number) => {
    const next = index === value ? 0 : index;
    onChange(next);
    // Clear hover highlight when unselecting
    if (next === 0) setHovered(0);
  };

  return (
    <Group gap={4} wrap="nowrap">
      {Array.from({ length: max }, (_, i) => {
        const index = i + 1;
        const filled = (hovered > 0 ? hovered : value) >= index;
        const color = getColor(index);
        return (
          <ActionIcon
            key={index}
            variant="subtle"
            color={undefined}
            style={{ color }}
            onMouseEnter={() => setHovered(index)}
            onMouseLeave={() => setHovered(0)}
            onClick={() => handleClick(index)}
            aria-label={`Set interest to ${index}`}
          >
            {filled ? <IconStarFilled size={size} /> : <IconStar size={size} />}
          </ActionIcon>
        );
      })}
    </Group>
  );
}

export default InterestRating;
